<template>
  <div class="ut-container-sm ut-pt-10">
    <tabs @changeTabs="changeTabs">
      <tab name="Your contact details" :selected="true">
        <account-contact-details-view
          v-if="profileEditMode === false"
          @edit-details="profileEditMode=true"
        />
        <account-contact-details-update
          v-else
          @cancel-edit-details="profileEditMode=false"
        />
      </tab>
      <tab name="Your sales" :selected="false">
        <account-sales v-if="agentIsLoaded" />
      </tab>
      <tab name="Your reviews" :selected="false">
        <account-reviews v-if="agentIsLoaded" />
      </tab>

      <tab
        name="Settings"
        :selected="false">
        <account-settings v-if="agentIsLoaded" />
      </tab>
    </tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Tabs from '@/components/Tabs.vue';
import Tab from '@/components/Tab.vue';
import AccountContactDetailsView from '@/components/Account/AccountContactDetailsView.vue';
import AccountContactDetailsUpdate from '@/components/Account/AccountContactDetailsUpdate.vue';
import AccountSales from '@/components/Account/AccountSales.vue';
import AccountReviews from '@/components/Account/AccountReviews.vue';
import AccountSettings from '@/components/Account/AccountSettings.vue';

export default {
  name: 'UserProfile',
  components: {
    Tabs,
    Tab,
    AccountContactDetailsView,
    AccountContactDetailsUpdate,
    AccountSales,
    AccountReviews,
    AccountSettings,
  },
  props: {
    ak: String,
  },
  created() {

  },
  mounted() {

  },
  data() {
    return {
      activeTab: '',
      profileEditMode: false,
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    agentIsLoaded() {
      return this.agent && this.agent.key;
    },
  },
  methods: {
    changeTabs(activeTab) {
      this.activeTab = activeTab;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
